import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { deleteDialog } from 'src/app/shared/dialog';
import { RoleService } from '../services/role.service';

interface IRole {
  roleId: string;
  name: string;
  permissionsCount: number;
  usersCount: number;
  creationDate: string;
}

@Component({
  selector: 'app-roles',
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.css']
})
export class RoleListComponent implements OnInit {

  roles: IRole[] = [];

  projectId: string | null = null;

  page = 0;
  size = 10;
  totalPages = 1;

  constructor(
    private router: Router,
    private roleService: RoleService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.projectId = this.route.snapshot.paramMap.get("projectId");
    this.loadRolesForProject();
  }




  loadRolesForProject() {
    this.roleService.getRolesForProject(this.projectId!, this.page, this.size)
      .subscribe({
        next: (res: any) => {
          this.roles = res.content.map((r: any) => ({
            roleId: r.roleId,
            name: r.name,
            permissionsCount: 0,
            usersCount: 0,
            creationDate: ""
          }));

          this.totalPages = res.totalPages;
        },
        error: (err) => console.error("Failed to load project roles", err)
      });
  }


  // ---------------------------------------------------
  // PAGINATION
  // ---------------------------------------------------
  nextPage() {
    if (this.page < this.totalPages - 1) {
      this.page++;
      this.loadRolesForProject()
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.loadRolesForProject()
    }
  }

  changeSize() {
    this.page = 0;
    this.loadRolesForProject()
  }


  // ---------------------------------------------------
  // VIEW ROLE
  // ---------------------------------------------------
  viewRole(id: string) {
    this.router.navigate(['/project-roles', this.projectId, 'role-details', id]);
  }


  editRole(id: string) {
    this.router.navigate(['/project-roles', this.projectId, 'role-edit', id]);
  }

}
